import { ChevronDown, ChevronUp, FileText } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
} from "../../../../components/ui/common/collapsible";
import { formatGenericIngredientDescription } from "../utils/genericIngredientDescription.utils";

interface GenericDatasetDescriptionProps {
  ingredientId: string;
  description: string | null;
  status: string | null;
  record: string | null;
  allocationMethod: string | null;
  databaseName: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const GenericDatasetDescription = ({
  ingredientId,
  description,
  status,
  record,
  allocationMethod,
  databaseName,
  open,
  onOpenChange
}: GenericDatasetDescriptionProps) => {
  if (!ingredientId) return null;

  return (
    <Collapsible open={open} onOpenChange={onOpenChange}>
      <CollapsibleTrigger asChild>
        <button
          type="button"
          className="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-2 tw-rounded-lg tw-border tw-border-border tw-bg-background tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-black hover:tw-bg-muted/50 tw-transition-colors"
        >
          <span className="tw-flex tw-items-center tw-gap-1.5 tw-text-black">
            <FileText className="tw-h-3.5 tw-w-3.5 tw-text-black" />
            Dataset description
            <span className="tw-text-[10px] tw-uppercase tw-tracking-wide tw-text-gray-700">
              (read only)
            </span>
          </span>
          {open ? (
            <ChevronUp className="tw-h-3.5 tw-w-3.5 tw-text-black" />
          ) : (
            <ChevronDown className="tw-h-3.5 tw-w-3.5 tw-text-black" />
          )}
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div
          className="tw-mt-2 tw-rounded-lg tw-border tw-border-border tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-leading-relaxed tw-text-black tw-whitespace-pre-wrap tw-max-h-56 tw-overflow-y-auto tw-select-text"
          aria-readonly="true"
        >
          {formatGenericIngredientDescription(
            description,
            status,
            record,
            allocationMethod,
            databaseName
          )}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default GenericDatasetDescription;
